export const UPDATE_DEPARTMENT = `
  mutation UpdateDepartment($id:ID!, $name: String!) {
    updateDepartment(id: $id, name: $name ){
      department {
        id
        name
      }
      errors {
        property	
        description
        
      }
    }
  } 
`;

export const GET_DEPARTMENTS = `
  query {
    departments {
      id
      name
    }
  }
`;

export const GET_DEPARTMENTS_WITH_USERS = `
  query {
    departments {
        id
        name
        users {
          id
          name
        }
    }
  }
`;

export const GET_DEPARTMENT = `
  query GetDepartment($id:ID!) {
    department(id: $id ){
      id
      name
      users {
        id
        name
        email
      }
    }
  }
`;

export const CREATE_DEPARTMENT = `
  mutation CreateDepartment($name:String!) {
    createDepartment(name: $name){
      department {
        id
        name
      }
      errors {
        property
        description
      }
    }
  }
`;